import type { MotionProps } from 'framer-motion';
import { motion } from 'framer-motion';
import type { CSSProperties, MouseEvent, ReactNode } from 'react';
type CustomMotionProps = {
  openVariants?: MotionProps['variants'];
  transition?: MotionProps['transition'];
  layout?: boolean | 'position' | 'size';
  initial?: MotionProps['initial'];
  animate?: MotionProps['animate'];
  exit?: MotionProps['exit'];
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
} & Omit<React.ComponentProps<typeof motion.div>, 'onClick' | 'style' | 'className' | 'children'>;
export default function CustomMotion({
  openVariants,
  transition,
  layout = false,
  initial,
  animate,
  exit,
  onClick,
  className,
  style,
  children,
  ...restProps
}: CustomMotionProps) {
  return <motion.div variants={openVariants ?? undefined} transition={transition ?? undefined} layout={layout} initial={initial} animate={animate} exit={exit} onClick={event => onClick?.(event)} className={className} style={style ?? undefined} {...restProps} data-sentry-element="unknown" data-sentry-component="CustomMotion" data-sentry-source-file="custom-motion.tsx">
      {children}
    </motion.div>;
}